import { Injectable } from '@angular/core';
import { ReportInventoryStocktakingPrintQuery, ReportInventoryStocktakingPrintQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ReportInventoryStocktakingPrintQuery)
@Wrapper(ReportInventoryStocktakingPrintQueryHandlerBase)
export class ReportInventoryStocktakingPrintQueryHandler {
    public constructor(
        http: Http
    ) { }
}
